import { createFileRoute } from '@tanstack/react-router';
import SettingsManagement from '../../components/manager/SettingsManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/settings')({
  component: SettingsManagementRoute,
});

function SettingsManagementRoute() {
  return (
    <ManagerPortal>
      <SettingsManagement />
    </ManagerPortal>
  );
}
